var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50042 5C1.50042 7.48528 3.51514 9.5 6.00042 9.5C7.79553 9.5 9.34514 8.44889 10.0674 6.92857M1.50042 5L2.94685 5.96429M1.50042 5L0.536133 6.44643M10.5004 5C10.5004 2.51472 8.4857 0.5 6.00042 0.5C4.20531 0.5 2.65569 1.55111 1.93347 3.07143M10.5004 5L9.05399 4.03571M10.5004 5L11.4647 3.55357",
    stroke: "#4262FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restart-icon.2bb2e9ebfb7fa0b75cc4088e96b0e81f.svg";
export { ForwardRef as ReactComponent };